import { useEffect, useState } from "react";
import QRCode from "qrcode";
import type { SlideProps } from "@/engine/app/offsite-config";

// PIN muss zum SSM-Passwort-Hash (/svo-offsite/netzkunden/password-hash) passen —
// beim Secrets-Setup gemeinsam setzen.
const WORKSHOP_PIN = "1913";
const WORKSHOP_URL =
  import.meta.env.VITE_WORKSHOP_URL ?? "https://netzkunden.offsite.svoos.de/";

function buildLoginUrl(): string {
  const u = new URL(WORKSHOP_URL);
  if (!u.pathname || u.pathname === "/") {
    u.pathname = "/m/login";
  }
  u.searchParams.set("pin", WORKSHOP_PIN);
  return u.toString();
}

export function Slide12Ueberleitung(_: SlideProps) {
  const [qrSvg, setQrSvg] = useState<string | null>(null);
  const [pinRevealed, setPinRevealed] = useState(false);

  useEffect(() => {
    QRCode.toString(buildLoginUrl(), {
      type: "svg",
      errorCorrectionLevel: "H",
      margin: 1,
      color: { dark: "#001E62", light: "#FFFFFF" },
    })
      .then(setQrSvg)
      .catch(() => setQrSvg(null));
  }, []);

  return (
    <div className="deck-root dark" style={{ background: "var(--svo-blau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 420,
          height: 420,
          top: "-100px",
          right: "-120px",
          background: "#fff",
          opacity: 0.08,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 320,
          height: 320,
          bottom: "-100px",
          left: "5%",
          background: "var(--svo-dunkelblau)",
          opacity: 0.25,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head" style={{ textAlign: "center", margin: "0 auto" }}>
        <div className="deck-eyebrow rise rise-1" style={{ color: "rgba(255,255,255,0.9)" }}>
          Übergang
        </div>
      </header>

      <div className="deck-hero">
        <div className="hero-statement rise rise-2">Jetzt seid ihr dran.</div>
        <div className="hero-divider rise rise-3" aria-hidden="true" />
        <div className="hero-sub rise rise-4">
          Der Strategietag war das Kennenlernen — heute wird es konkret:
          euer Thema, echtes KI-Feedback, ein richtiger Prototyp.
        </div>

        <div className="login-qr-card rise rise-5">
          <div className="login-qr-svg" aria-hidden="true">
            {qrSvg ? (
              <span dangerouslySetInnerHTML={{ __html: qrSvg }} />
            ) : (
              <div className="login-qr-placeholder">…</div>
            )}
          </div>
          <div className="login-qr-info">
            <div className="login-qr-eyebrow">Mit dem Handy scannen</div>
            <div className="login-qr-url">{WORKSHOP_URL.replace(/^https?:\/\//, "")}</div>
            <button
              type="button"
              className="login-qr-pw login-qr-pw-reveal"
              data-revealed={pinRevealed}
              onClick={() => setPinRevealed((v) => !v)}
              aria-label={pinRevealed ? "PIN ausblenden" : "PIN einblenden"}
            >
              <span className="label">PIN:</span>
              {pinRevealed ? (
                <code>{WORKSHOP_PIN}</code>
              ) : (
                <>
                  <code aria-hidden="true">••••</code>
                  <span className="reveal-hint">klicken zum Anzeigen</span>
                </>
              )}
            </button>
            {pinRevealed && (
              <div className="login-qr-funfact">
                <span className="ff-label">Fun Fact</span>
                <span>
                  1913 beschlossen die Kreise Celle und Uelzen den Bau des
                  Stromnetzes — daraus entstand die SVO.
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
